import '../styles/index.scss';

import 'bootstrap/dist/js/bootstrap.min';
import 'jscrollpane/script/jquery.jscrollpane.min';
import 'jscrollpane/script/jquery.mousewheel';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.fr';

// components
import Select from './components/select';
import Scroll from './components/scroll';
import Tab from './components/tab';

// Pages
import Mission from './mission';
import Formation from './formation';

import Script from './theme/script';
import Localization  from './theme/localization';
import "jquery-validation/dist/additional-methods.js";

import $ from 'jquery';

import './components/common';


$(document).ready(() => {
    const select = new Select(document.querySelectorAll('.s-select'));
    const scroll = new Scroll(document.querySelectorAll('.scroll-js'));
    const mission = new Mission();
    const formation = new Formation();
    const script = new Script();
    const tab = new Tab();
    select.init();
    mission.init();
    formation.init();
    script.init();
    tab.init();
    scroll.init();
   // $('.scroll-js').niceScroll();

});

